import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-[20px] text-center flex flex-col justify-between h-auto md:h-[360px] lg:md:h-[336px] w-full md:w-[502px] px-10 py-6" }
const _hoisted_2 = { class: "text-2xl font-semibold leading-[32px] text-brown mb-10" }
const _hoisted_3 = { class: "text-base leading-[20px] text-black mb-10 text-left" }
const _hoisted_4 = { class: "flex justify-center" }


import { ROUTE_NAMES } from "@/constants/routeNames";
import { useRouter } from "vue-router";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'TarotCalculatorCard',
  props: {
    cardTitle: {},
    cardText: {},
    calculatorRoute: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const { t } = useI18n();

function openCalculator() {
  router.push({ name: props.calculatorRoute });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(__props.cardTitle), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.cardText), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(GradientButton, {
        class: "w-[169px] h-14",
        "bg-color": "bg-brown-gradient",
        "hover-bg-color": "bg-orange-gradient",
        text: _unref(t)('buttons.go'),
        onClick: openCalculator
      }, null, 8, ["text"])
    ])
  ]))
}
}

})